import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import FacturacaoAgregadaLayer from "../components/FacturacaoAgregadaLayer";
import { useTranslation } from "../i18n/I18nContext";

const FacturacaoAgregadaPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("bulk.breadcrumb")} />
      <FacturacaoAgregadaLayer />
    </MasterLayout>
  );
};

export default FacturacaoAgregadaPage;
